<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <v-btn
    @click="$emit('click')"
    :loading="loading"
    :disabled="disabled"
    :block="block"
    elevation="0"
    color="amber lighten-4 black--text"
  >
    <v-icon left>
      {{ icon }}
    </v-icon>
    {{ $t(text) }}
  </v-btn>
</template>

<script>
export default {
  name: 'PrimaryButton',
  props: {
    block: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: 'OK'
    },
    icon: {
      type: String,
      default: 'mdi-check'
    }
  }
}
</script>

<style scoped>

</style>
